import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import { dynamicStaticPageValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

import r from 'quill/dist/quill.snow.css';
import s from './Page.css';
import t from '../../styles/customQuillEditor.css'

class Page extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    html: PropTypes.string,
    data: PropTypes.object,
    intl: PropTypes.object
  };

  render() {
    const { title, html, data, intl: { locale } } = this.props;
    let pageTitle = title;
    let pageHtml = html;

    if (data) {
      const dynamicData = dynamicStaticPageValue(data, locale);
      pageTitle = dynamicData.metaTitle || data.metaTitle;
      pageHtml = dynamicData.content || data.content;
    }

    let addClass = 'ql-editor frontend';
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.previewPageWrapper}>
            <h1>{pageTitle}</h1>
            <div className={addClass}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: pageHtml }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(withStyles(r, s, t)(Page));
